<template>
  <div>
    <LoginPopUpComponent
      v-if="!isAuthenticated"
      @authenticated="handleLoginSuccess"
    />
    <div v-else class="admin-container">
      
      <div class="tabs">
        <button
          :class="{ active: activeTab === 'associations' }"
          @click="activeTab = 'associations'"
        >
          Associations
        </button>
        <button
          :class="{ active: activeTab === 'infos' }"
          @click="activeTab = 'infos'"
        >
          Infos
        </button>
      </div>

      <!-- Onglet Associations -->
      <div v-if="activeTab === 'associations'">
        <div class="search-wrapper">
          <FontAwesomeIcon icon="search" class="search-icon" />
          <input
            class="search"
            type="text"
            v-model="searchTerm"
            placeholder="Rechercher une association"
          />
          <button class="add-btn" @click="openAddForm">
            Ajouter un service
          </button>
        </div>

        <div class="cards">
          <div v-for="asso in filteredAssociations" :key="asso.id">
            <DeleteAssociationComponent
              :nom="asso.name"
              :image="asso.image"
              :description="asso.description"
              :lieux="asso.lieuxTitles"
              @delete="openDeleteModal(asso)"
            >
              <template #footer>
                <button class="btn-delete" @click="openDeleteModal(asso)">Supprimer</button>
                <button class="btn-edit" @click="openEditForm(asso)">Modifier</button>
              </template>
            </DeleteAssociationComponent>
          </div>
        </div>
      </div>

      <!-- Onglet Infos -->
      <div v-else-if="activeTab === 'infos'">
        <div class="infos-header">
          <button class="add-btn" @click="openAddInfoForm">
            Ajouter une info
          </button>
        </div>
        <EditInfosComponent
          @delete="openDeleteInfoModal"
          @edit="openEditInfoModal"
        />
      </div>

      <div
        v-if="showAddForm"
        class="modal-overlay"
        @click.self="closeAddForm"
      >
        <div class="modal" ref="modalContainer">
          <AddAssociationForm @close="closeAddForm" />
        </div>
      </div>

      <div
        v-if="showEditForm"
        class="modal-overlay"
        @click.self="closeEditForm"
      >
        <div class="modal" ref="editModal">
          <EditAssociationForm
            :association="editAssociation"
            @close="closeEditForm"
          />
        </div>
      </div>

      <div
        v-if="showAddInfoForm"
        class="modal-overlay"
        @click.self="closeAddInfoForm"
      >
        <div class="modal" ref="infoModal">
          <AddInfoForm @close="closeAddInfoForm" />
        </div>
      </div>

      <!-- modale de suppression unique -->
      <DeleteAssociationModal
        v-if="showDeleteModal"
        :nom="deleteTarget.name"
        @confirm="confirmDelete"
        @cancel="closeDeleteModal"
      />

      <DeleteInfoModal
        v-if="showDeleteInfoModal"
        :nom="deleteInfoTarget.name"
        @confirm="confirmDeleteInfo"
        @cancel="closeDeleteInfoModal"
      />


      <div
        v-if="showEditInfoModal"
        class="modal-overlay"
        @click.self="closeEditInfoForm"
      >
       <div class="modal" ref="editInfoModal">
          <EditInfoForm
            :info="editInfo"
            @close="closeEditInfoForm"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoginPopUpComponent from '../components/LoginPopUpComponent.vue';
import DeleteAssociationComponent from '../components/Associations/DeleteAssociationComponent.vue';
import AddAssociationForm from '../components/Associations/AddAssociationForm.vue';
import EditAssociationForm from '../components/Associations/EditAssociationForm.vue';
import DeleteAssociationModal from '../components/Associations/DeleteAssociationModal.vue';
import EditInfosComponent from '../components/Infos/EditInfosComponent.vue';
import AddInfoForm from '../components/Infos/AddInfoForm.vue';
import DeleteInfoModal from '../components/Infos/DeleteInfoModal.vue';
import EditInfoForm from '../components/Infos/EditInfoForm.vue';


import { mapGetters } from 'vuex';

export default {
  components: {
    LoginPopUpComponent,
    DeleteAssociationComponent,
    AddAssociationForm,
    EditAssociationForm,
    DeleteAssociationModal,
    EditInfosComponent,
    AddInfoForm,
    DeleteInfoModal,
    EditInfoForm
  },
  data() {
    return {
      isAuthenticated: false,
      searchTerm: '',
      showAddForm: false,
      showEditForm: false,
      showDeleteModal: false,
      showAddInfoForm: false,
      deleteTarget: null,
      editAssociation: null,
      activeTab: 'associations',
      showDeleteInfoModal:false,
      deleteInfoTarget:null,
      showEditInfoModal:false,
      editInfo:null
    };
  },
  computed: {
    ...mapGetters(['getCategories', 'getPlaces', 'getAssociations']),
    filteredAssociations() {
      if (!this.searchTerm) return this.getAssociations;
      const term = this.searchTerm.toLowerCase();
      return this.getAssociations.filter(a =>
        a.name.toLowerCase().includes(term)
      );
    }
  },
  methods: {
    handleLoginSuccess() {
      this.isAuthenticated = true;
      this.afterLogin();
    },
    afterLogin() {
      this.$store.dispatch('loadAssociations');
    },
    openAddForm() {
      this.showAddForm = true;
      this.$nextTick(() => {
        this.$refs.modalContainer.scrollTop = 0;
      });
    },
    closeAddForm() {
      this.showAddForm = false;
    },
    openEditForm(association) {
      this.editAssociation = association;
      this.showEditForm = true;
      this.$nextTick(() => {
        this.$refs.editModal.scrollTop = 0;
      });
    },
    openEditInfoModal(info) {
      this.editInfo = info;
      this.showEditInfoModal = true;
      this.$nextTick(() => {
        this.$refs.editInfoModal.scrollTop = 0;
      });
    },
    closeEditForm() {
      this.editAssociation = null;
      this.showEditForm = false;
    },
    closeEditInfoForm(){
      this.editInfo = null;
      this.showEditInfoModal = false;
    },
    openDeleteModal(association) {
      this.deleteTarget = association;
      this.showDeleteModal = true;
    },
    closeDeleteModal() {
      this.deleteTarget = null;
      this.showDeleteModal = false;
    },
    openDeleteInfoModal(info) {
      this.deleteInfoTarget = info;
      this.showDeleteInfoModal = true;
    },
    closeDeleteInfoModal() {
      this.deleteInfoTarget = null;
      this.showDeleteInfoModal = false;
    },
    confirmDelete() {
      this.$store
        .dispatch('deleteAssociation', this.deleteTarget.id)
        .then(() => this.closeDeleteModal());
    },
    confirmDeleteInfo() {
      this.$store
        .dispatch('deleteInfo', this.deleteInfoTarget.id)
        .then(() => this.closeDeleteInfoModal());
    },
    openAddInfoForm() {
      this.showAddInfoForm = true;
      this.$nextTick(() => {
        this.$refs.infoModal.scrollTop = 0;
      });
    },
    closeAddInfoForm() {
      this.showAddInfoForm = false;
    }
  }
};
</script>

<style scoped>
.admin-container {
  margin: auto;
  padding: 2rem;
  text-align: center;
  align-content: center;
  justify-content: center;
}

/* Styles des onglets */
.tabs {
  display: flex;
  justify-content: center;
  margin-bottom: 1.5rem;
}
.tabs button {
  background: none;
  border: none;
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  transition: border-color 0.2s;
}
.tabs button.active {
  border-color: #1E1C66;
  font-weight: bold;
}

.infos-header {
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 800px;
  margin: 0 auto 1rem;
}

h1, h2 {
  color: #1E1C66;
  margin-bottom: 1rem;
}

.cards {
  margin-left: 5%;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 1rem;
}

/* Barre de recherche + bouton */
.search-wrapper {
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 500px;
  margin: 0 auto 1.5rem;
  position: relative;
}

.search-icon {
  position: absolute;
  left: 1rem;
  font-size: 1rem;
  color: #bbb;
  pointer-events: none;
}

.search {
  flex: 1;
  padding: 0.75rem 1rem 0.75rem 2.5rem;
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.08);
  transition: border-color 0.3s, box-shadow 0.3s;
}

.search:focus {
  outline: none;
  border-color: #1E1C66;
  box-shadow: 0 0 0 3px rgba(30,28,102,0.15);
}

.add-btn {
  margin-left: 0.75rem;
  background-color: #167580;
  border: none;
  padding: 0.75rem 1.25rem;
  border-radius: 8px;
  color: #fff;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
}

.add-btn:hover {
  background: #393776;
}

/* Styles de la modale */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
}

.modal {
  background: #fff;
  border-radius: 8px;
  padding: 1.5rem;
  max-width: 600px;
  max-height: 80vh;
  width: 100%;
  overflow-y: auto;
  box-shadow: 0 4px 12px rgba(0,0,0,0.2);
}

.btn-delete {
  flex: 1;
  background-color: #B82828;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 0.5rem;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.2s;
}
.btn-delete:hover {
  background-color: #9e1f1f;
}

.btn-edit {
  flex: 1;
  background-color: #167580;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 0.5rem;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.2s;
}
.btn-edit:hover {
  background-color: #393776;
}
</style>